export default "__VITE_ASSET__B74nXt5v__"